import Icon from 'veui/components/Icon'
import { IconFilter } from 'dls-icons-vue'

Icon.register('filter', IconFilter)
